import { CROSSWORD_PUBLISHER_DATA } from "../consts/crosswords";

export const getCrosswordPublisherByCrosswordId = (crosswordId) => {
	const publisherData = CROSSWORD_PUBLISHER_DATA.find(
		(publisher) => publisher.crosswordId === crosswordId
	);
	return publisherData || null;
};

export const getCrosswordPublisherBySlug = (slug) => {
	const publisherData = CROSSWORD_PUBLISHER_DATA.find(
		(publisher) => publisher.slug === slug
	);
	return publisherData || null;
};
